import { memo } from "react";
import { number } from "@euroland/format-number";
import { mergeObject, replaceKey } from "../../utils";
import { HighChartWrapper, defaultOptions } from "@euroland/react-high-chart";
import {i18n} from "@euroland/libs";
import { getCurrencyLabel, isUseLatinNumber } from "../../store/utils";
import Highcharts from "./setup";
import { formatNumberByInstrument } from "../../utils/format-number";
/**
 * @typedef {import ('../../..').IAnnualClosePrice} IAnnualClosePrice
 */

/**
 * Despite the fact that time are not same, chart column spacing is the same
 * @param {IAnnualClosePrice} data
 * @param { string } currencyCode
 * @returns { any }
 */
const createOptions = (data, currencyCode) => chartUtils => {
  const { loadStyle, loadCommonStyle } = chartUtils;
  let datas = data.datas;
  const instrumentId = data.instrumentId;
  if (window.innerWidth < 768) {
    const maxColumn = loadStyle("--chart-column-mobile-max-column", 5, "number").toNumber();

    if (maxColumn < datas.length) {
      datas = datas.slice(datas.length - maxColumn, datas.length);
    }
  }
  const result = mergeObject(defaultOptions(chartUtils), {
    xAxis: {
      categories: datas.map(item => {
        const year = new Date(item.date).getFullYear();

        return number(year, "###0");
      }),
    },
    yAxis: {
      title: {
        text: getCurrencyLabel(currencyCode),
        textAlign: 'right',
        style: {
          'padding-left': '1rem'
        }
      },
      labels: {
        formatter: function () {
          return formatNumberByInstrument(this.value, instrumentId);
        },
      },
    },
    series: [
      {
        type: "column",
        data: datas.map(item => item.price),
        pointWidth: loadStyle("--chart-column-width", 50, "px").toNumber(),
        color: loadStyle("--chart-column-color", "var(--color-primary)", "color").get(),
        borderRadius: loadStyle("--chart-column-border-radius", 0, "px").toNumber(),
        dataLabels: {
          enabled: true,
          align: "center",
          useHTML: true,
          inside: loadStyle(
            "--chart-column-labels-inside",
            false,
            "labels inside column, true | false"
          ).toBoolean(),
          rotation: loadStyle("--chart-column-labels-rotation", 0, "rotation px").toNumber(),
          formatter: function () {
            return formatNumberByInstrument(this.y, instrumentId);
          },
          style: loadCommonStyle("--chart-column-labels"),
        },
      },
    ],
  });
  return result;
};

/**
 * extends victor option and overwrite
 * @param {IAnnualClosePrice} data
 * @param { string } currencyCode
 * @returns { any }
 */
const createOptionsQuadrata = (data, currencyCode) => chartUtils => {
  const victorOption = createOptions(data, currencyCode)(chartUtils);
  return victorOption;
};

/**
 *
 * @param {{
 *  data: IAnnualClosePrice
 * }} param0
 * @returns
 */
export const HighChartsColumnVictor = memo(
  ({ data, tickerName, marketCode, marketName, currencyCode }) => {
    return (
      <div className="victor-charts-column">
        <div className="chart-title">
          <span>{tickerName}</span>{" "}
          <span className="chart-title__currency" aria-label={marketName} role="heading" aria-level={1}>
            {replaceKey(i18n.translate("currencyFormat"), [marketCode])}
          </span>
        </div>
        <HighChartWrapper
          createOptions={createOptions(data, currencyCode)}
          highCharts={Highcharts}
          allowChartUpdate
          immutable={true}
          isRtl={window.appSettings.isRtl}
        />
      </div>
    );
  },
  (prev, next) => prev.data === next.data
);

/**
 *
 * @param {{
 *  data: IAnnualClosePrice
 * }} param0
 * @returns
 */
export const HighChartsColumnQuadrata = memo(
  ({ data, tickerName, marketCode, marketName, currencyCode, isSingle }) => {
    return (
      <div className="quadrata-charts-column">
        {!isSingle && (
          <div className="chart-title">
            <span>{tickerName}</span>{" "}
            <span className="chart-title__currency" aria-label={marketName} role="heading" aria-level={1}>
              {replaceKey(i18n.translate("currencyFormat"), [marketCode])}
            </span>
          </div>
        )}
        <HighChartWrapper
          createOptions={createOptionsQuadrata(data, currencyCode)}
          highCharts={Highcharts}
          allowChartUpdate
          immutable={true}
          isRtl={window.appSettings.isRtl}
        />
      </div>
    );
  },
  (prev, next) => prev.data === next.data && prev.isSingle === next.isSingle
);
